import { useEffect, useState } from 'react'
import React from 'react'

import classnames from 'classnames'

import Text, { TextSizes } from '../Text/Text'

import styles from './Checkbox.module.css'

export interface CheckboxProps {
  id: string
  checked?: boolean
  disabled?: boolean
  invalid?: boolean
  label?: string
  name?: string
  value?: string
  hideLabel?: boolean
  onChange?: (event: React.FormEvent<HTMLInputElement>) => void
  testID?: string
  smallFont?: boolean
  count?: number
  testAttr?: string
  lozengeStyle?: boolean
}

export default function Checkbox({
  id,
  checked = false,
  disabled = false,
  hideLabel = false,
  invalid = false,
  label,
  name,
  value,
  onChange,
  testID,
  smallFont = false,
  count,
  testAttr = 'checkbox',
  lozengeStyle = false,
}: CheckboxProps) {
  const [isChecked, setChecked] = useState<boolean | undefined>(checked)
  const handleChange = (evt: React.FormEvent<HTMLInputElement>) => {
    setChecked(!isChecked)
    onChange?.(evt)
  }
  useEffect(() => {
    setChecked(checked)
  }, [checked])

  return (
    <div className={classnames(lozengeStyle && styles.lozengeStyle)}>
      <input
        id={id}
        type="checkbox"
        checked={isChecked}
        name={name}
        value={value}
        disabled={disabled}
        onChange={evt => handleChange(evt)}
        className={classnames(
          styles.checkbox,
          { [styles.invalid]: invalid },
          { [styles.smallFont]: smallFont }
        )}
        data-testid={testID}
      />
      <label
        htmlFor={id}
        data-testid={testID && `label-${testID}`}
        className={classnames(styles.label, smallFont && styles.labelSmall)}
        data-test={testAttr}
      >
        <span className={styles.labelContainer}>
          {label && (
            <Text
              size={
                lozengeStyle
                  ? TextSizes.bodyMed
                  : smallFont
                    ? TextSizes.bodySml
                    : TextSizes.bodyMed
              }
              className={classnames({ ['visually-hidden']: hideLabel })}
            >
              {label}
              {count && <span className={styles.count}>{count}</span>}
            </Text>
          )}
        </span>
      </label>
    </div>
  )
}
